import { Document } from './Document';
import { Quiz } from './Quiz';
import { Video } from './Video';

export const Cards = {
  Document,
  Quiz,
  Video,
};
